import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServerlessProvider } from './serverless';
import { SystemDashboardUsersApiRequest } from './models/system-dashboard-users-api-request';
import { SystemDashboardUsersApiResponse } from './models/system-dashboard-users-api-response';
import { SystemDashboardUser } from "./models/system-dashboard-user";
import { GenericItem } from './models/generic-item';

/**
 * [システム][ダッシュボード]ユーザー一覧 APIの通信用プロバイダー.
 */
@Injectable()
export class SystemDashboardUsersServiceProvider {

  /** APIのパス */
  private readonly PATH = '/v3/system/dashboardUsers';

  constructor(public serverless: ServerlessProvider) { }

  /**
   * ユーザー一覧を取得する.
   * 
   * @param userIds ユーザーIDの一覧
   * @returns ユーザー一覧, 画像URLプレフィックス
   */
  public get(userIds: number[]): Observable<[SystemDashboardUser[], string]> {
    const requestBody: SystemDashboardUsersApiRequest = { userIds: userIds };
    return this.serverless.postApi<SystemDashboardUsersApiRequest, GenericItem<SystemDashboardUsersApiResponse>>
      (this.PATH, requestBody).map((responseBody) => this.toModel(responseBody));
  }

  /**
   * レスポンスボディをモデルに変換する.
   * 
   * @param responseBody レスポンスボディ
   * @returns ユーザー一覧, 画像URLプレフィックス
   */
  private toModel(responseBody: GenericItem<SystemDashboardUsersApiResponse>): [SystemDashboardUser[], string] {
    return [
      responseBody.item.users,
      responseBody.item.imgUrlPrefix
    ];
  }
}



// WEBPACK FOOTER //
// ./src/providers/servicer/system-dashboard-users-service.ts